import React from 'react'
import {Navigate} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {getAllUserDetails} from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

interface Props {
  children: JSX.Element
}

export const Admin_Staff = ['superAdmin', 'staffAdmin', 'sales', 'accountManager', 'support', 'subAdmin', 'FEuserAdmin']

/**
 * Route guard that allows access only to users whose role is "owner" or belongs to the admin role group (`Admin_Staff`).
 * If the current user's role does not meet the requirement, the component redirects to the 404 error page.
 */
const AdminOwnerRoute: React.FC<Props> = ({children}) => {
  // Prefer role from Redux store; fall back to localStorage in edge cases (e.g. on refresh before Redux is ready)
  const userDetails = useSelector(getAllUserDetails)
  const reduxRole = userDetails?.data?.user?.role

  let role: string | null = reduxRole ?? null
  if (!role) {
    const storedRole = localStorage.getItem('role')
    if (storedRole) {
      try {
        role = JSON.parse(storedRole)
      } catch (_) {
        role = storedRole
      }
    }
  }

  const isAllowed = role === 'owner' || (role ? Admin_Staff.includes(role) : false)

  if (!isAllowed) return <Navigate to='/error/404' replace />

  return children
}

export default AdminOwnerRoute 
